var map = {
	"./catalog1.jpg": 4750,
	"./dhoop_box1.jpg": 9245,
	"./dhoop_box2.jpg": 3423,
	"./dhoop_box3.jpg": 6869,
	"./dhoop_box4.jpg": 869,
	"./garment_box1.jpg": 1523,
	"./garment_box2.jpg": 1022,
	"./garment_box3.jpg": 8645,
	"./garment_box4.jpg": 7840,
	"./garment_box5.jpg": 4152,
	"./incense_stick1.jpg": 4159,
	"./incense_stick2.jpg": 5447,
	"./incense_stick4.jpg": 747,
	"./incense_stick5.jpg": 2450,
	"./incense_stick6.jpg": 9170,
	"./label1.jpg": 237,
	"./label2.jpg": 1237,
	"./label3.jpg": 3865,
	"./letter1.jpg": 9210,
	"./letter2.jpg": 5034,
	"./letter3.jpg": 422,
	"./letter4.png": 7537,
	"./luxury1.jpg": 2877,
	"./luxury2.jpg": 9993,
	"./luxury3.jpg": 8219,
	"./luxury4.jpg": 8861,
	"./sticker1.jpg": 3227,
	"./sticker2.jpg": 955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7257;